<template>
	<TheHeader></TheHeader>

	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>

					<div class="page-container card col-md-8">
						<ThePageHeader></ThePageHeader>

						<div class="row" v-if="pageError == ''">
							
							<div class="row p-3">
								<div class="col-md-6">
									<Button class="p-button-sm" @click="add" label="Create New Journal" :hidden="isViewer" />
								</div>
							</div>
							
							<div class="row p-3 pb-0">
								<label><b>Search existing Journal by:</b></label>
							</div>
							
							<div class="row p-3 pb-0">
								<div class="col-md-6">
									<InputText class="p-inputtext" type="text" maxlength="100" placeholder="Conso Group Name" v-model="filterConsoGroupNameModel.value" />
								</div>
								<div class="col-md-6">
									<Calendar dateFormat="yy-mm-dd" selectionMode="range" :manualInput="true" placeholder="Balance Sheet Date (range)" v-model="filterBalanceSheetDateModel" />
								</div>
							</div>

							<div class="row p-3">
								<div class="col-md-6">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="File ID" v-model="filterFileIdModel.value" />
								</div>
								<div class="col-md-6">
									<Dropdown :options="journalApplicationStatuses" optionLabel="name" optionValue="value" placeholder="Status" v-model="filterStatusModel.value" />
								</div>
							</div>

							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search" />
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset" />
								</div>

								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>

							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
										<tr>
											<th style="width: 8%;">#</th>
											<th style="width: 42%; cursor: pointer;" @click="sort('x.consoGroupName')">Conso Group <span class="pi" :class="[sortingModel.columnName == 'x.consoGroupName' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
											<th style="width: 20%; cursor: pointer;" @click="sort('x.balanceSheetDate')">File ID <span class="pi" :class="[sortingModel.columnName == 'x.balanceSheetDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
											<th style="width: 15%; cursor: pointer;" @click="sort('x.statusDate')">Status Date <span class="pi" :class="[sortingModel.columnName == 'x.statusDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
											<th style="width: 15%;" class="text-center">Status</th>
										</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
										<tr v-for="(journal, index) in pagination.journals" :key="index" v-on:click="view(journal)">
											<td>{{ ((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1 }}</td>
											<td>{{ journal.consoGroupName }}</td>
											<td>{{ journal.fileId  }}</td>
											<td>{{ journal.statusDate }}</td>
											<td class="text-center">
												<Badge class="mr-2" :class="[journal.status == 'Consolidated' ? 'p-badge-success' : (journal.status == 'Cancelled' ? 'p-badge-danger' : 'p-badge-warning')]" :value="journal.status"></Badge>
												</td>
										</tr>
										</tbody>
									</table>
								</div>

								<div class="error-no-record" v-if="!isLoading && pagination.journals.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>

								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>

					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import journalApi from "@/api/journal-api";
	import roleMixin from "@/mixin/role";
	import statusMixin from "@/mixin/status";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import applicationStatusMixin from "@/mixin/application-status";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";

	export default defineComponent({
		mixins: [roleMixin, statusMixin, dateUtilsMixin, applicationStatusMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			ThePageError
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, journals: [], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.balanceSheetDate", isAscending: false} : store.getters.getCached.page.sortingModel),
				filterConsoGroupNameModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterConsoGroupNameModel),
				filterBalanceSheetDateModel: (store.getters.getCached.page == null ? null as any[] | null : store.getters.getCached.page.filterBalanceSheetDateModel),
				filterFileIdModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterFileIdModel),
				filterStatusModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterStatusModel),
				isLoading: false,
			}
		},
		watch: {
			filterLegalGroup(newValue: any) {
				this.pagination = {currentPage: 1, itemsPerPage: 10, companies: [], totalItems: 0};
				this.find(1);
			}
		},
		mounted: function () {
			if (this.pageError == '') {
				this.find(this.pagination.currentPage);
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			},
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			}
		},
		methods: {
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;

				store.getters.getCached.page = {
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterConsoGroupNameModel: JSON.parse(JSON.stringify(this.filterConsoGroupNameModel)),
					filterBalanceSheetDateModel: this.filterBalanceSheetDateModel,
					filterFileIdModel: JSON.parse(JSON.stringify(this.filterFileIdModel)),
					filterStatusModel: JSON.parse(JSON.stringify(this.filterStatusModel)),
				};

				journalApi.journalFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterLegalGroupModel: {value: this.filterLegalGroup},
						filterConsoGroupNameModel: this.filterConsoGroupNameModel,
						filterStartBalanceSheetDateModel: {value: (this.filterBalanceSheetDateModel != null && this.filterBalanceSheetDateModel[0] != null ? this.formatToDate(this.filterBalanceSheetDateModel[0]) : null)},
						filterEndBalanceSheetDateModel: {value: (this.filterBalanceSheetDateModel != null && this.filterBalanceSheetDateModel[1] != null ? this.formatToDate(this.filterBalanceSheetDateModel[1]) : null)},
						filterFileIdModel: this.filterFileIdModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, journals: response.data.rowSet, totalItems: response.data.totalItems}
						if (store.getters.getCached.page == null) {
							store.getters.getCached.page = {};
						}
						store.getters.getCached.page.pagination = this.pagination;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, journals: [], totalItems: 0};
				this.sortingModel = {columnName: "x.balanceSheetDate", isAscending: false};
				this.filterConsoGroupNameModel = {value: ""};
				this.filterBalanceSheetDateModel = null as any[] | null;
				this.filterFileIdModel = {value: ""};
				this.filterStatusModel = {value: null};
				this.find(1);
			},
			add() {
				this.$router.push("/journal/add");
			},
			view(journal: any) {
				this.$router.push("/journal/" + journal.identifier);
			}
		}
	})
</script>